module.exports = __webpack_public_path__ + "img/avatar1.71634e61.png";